import React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { useCountUp } from '../../userPages/dashboard/managerOverview/overviewTheme'

// Card shell every wallboard widget renders inside. Fills its grid cell; the
// content area is a column flex with minHeight 0 so lists can clip instead of
// stretching the cell (and charts get explicit pixel heights, never flex —
// see the ChartCard resize-loop gotcha).
export const WidgetFrame = ({ title, accent, action, children }) => (
  <Paper
    variant="outlined"
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      p: 2,
      position: 'relative',
      overflow: 'hidden',
      bgcolor: 'background.paper',
    }}
  >
    {accent && (
      <Box
        aria-hidden="true"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          backgroundColor: accent,
        }}
      />
    )}
    {(title || action) && (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.95rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
          }}
        >
          {title}
        </Typography>
        {action}
      </Stack>
    )}
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      {children}
    </Box>
  </Paper>
)

export const WidgetUnavailable = ({ label = 'Data unavailable' }) => (
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography sx={{ color: 'text.secondary' }}>{label}</Typography>
  </Box>
)

// Big TV-legible number with the dashboard count-up
export const BigNumber = ({ value, label, color }) => {
  const counted = useCountUp(value ?? 0)
  const displayValue = value == null ? '—' : counted
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Typography
        component="div"
        sx={{
          fontWeight: 700,
          fontSize: 'clamp(2.4rem, 5vw, 4.4rem)',
          lineHeight: 1.05,
          color: color ?? 'text.primary',
        }}
      >
        {displayValue}
      </Typography>
      {label && (
        <Typography sx={{ color: 'text.secondary', fontSize: '1rem' }}>
          {label}
        </Typography>
      )}
    </Box>
  )
}
